import {http} from "../http";

export interface RuleTransactionButton{
    save : boolean;
    sign : boolean;
    approve : boolean;
    send : boolean;
}

export const getTransactionButtons = async (): Promise<RuleTransactionButton> => {
    const { data } = await http.post<RuleTransactionButton>("auth/rule-transaction-button");
    return data;
};
